export const OPENING_HOURS = {
  1000: 'calendar.opening_hours_park',
  1001: 'calendar.opening_hours_play',
};

export const CALENDAR_NAME = {
  1000: 'resort.safari_resort',
  1001: 'resort.speelland',
};
